export class HelpVideo {
  id: number;
  name: string;
  description: string;
  lastModified: Date;
  url: string;
  new: boolean;
}